import React from 'react';
import Ax from "../../components/hoc/Ax";

export default (props) => <Ax>
    {/* <label className='form-label'>Asset Name : {props.assetDetail.name} </label> <br />
    <label className='form-label'>Code : {props.assetDetail.asset_code}</label><br /> */}
    <label className='form-label'>Asset Type (Asset Matrix) : {props.assetDetail.asset_type_name ?? "-"} ({props.assetDetail.asset_matrix_unique_id ?? "-"})</label> <br />
    <label className='form-label'>Manufacturer (Model): {props.assetDetail.manufacturer_name ?? "-"} ({props.assetDetail.model_name ?? "-"})</label>
    <div className='form-label'>Current Site: {props.assetDetail.site ?? "-"} ({props.assetDetail.site_code ?? "-"})</div>
</Ax>;